import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ed20806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "map__window"
}, null, -1))

import BaseButton from '@/components/BaseButton.vue'
import { DEFAULT_COORDINATES } from '@/enums/services'
import { FORMATS, SIZES } from '@/enums/components'
import { computed, reactive, watch, PropType, onUnmounted } from 'vue'
import { GoogleCoordinates } from '@/models/location.model'
import { useI18n } from 'vue-i18n'


export enum CLICK_MODE {
  NONE = 'NONE',
  MARKER = 'MARKER',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleMap',
  props: {
  latitude: {
    type: Number,
    default: null,
  },
  longitude: {
    type: Number,
    default: null,
  },
  showPin: {
    type: Boolean,
    default: false,
  },
  clickMode: {
    type: String as PropType<CLICK_MODE>,
    default: CLICK_MODE.NONE,
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  hideCoordinates: {
    type: Boolean,
    default: false,
  },
  zoom: {
    type: Number,
    default: 15,
  },
},
  emits: ['coordinates'],
  setup(__props) {

const props = __props

const i18n = useI18n()


const apiKey = process.env.VUE_APP_GOOGLE_API_KEY

const coordinates = reactive<GoogleCoordinates>({
  lat: props.latitude || DEFAULT_COORDINATES.LATITUDE_ESTONIA,
  lng: props.longitude || DEFAULT_COORDINATES.LONGITUDE_ESTONIA,
})
const zoom = computed(() =>
  props.latitude && props.longitude ? props.zoom : 8,
)

const contentString = computed(
  () =>
    `${i18n.t('coordinates.label')}: ${coordinates.lat}, ${coordinates.lng}`,
)

const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`
const scripts = document.getElementsByTagName('script')

onUnmounted(() => {
  // remove old script if there is one
  for (let sc = 0; sc < scripts.length; sc++) {
    if (scripts[sc].src === url) {
      scripts[sc].parentNode?.removeChild(scripts[sc])
    }
  }
})

// add google script to document head
const script = document.createElement('script')
script.src = url
script.async = true
document.head.appendChild(script)

function initMap() {
  const map = new google.maps.Map(document.getElementById('map'), {
    center: coordinates,
    zoom: zoom.value,
  })

  let marker = undefined
  // Should we show the first pin froms props
  if (props.showPin && props.latitude && props.longitude) {
    marker = addMarker()
  }

  if (props.clickMode === CLICK_MODE.MARKER) {
    map.addListener('click', (event: google.maps.MapMouseEvent) => {
      Object.assign(coordinates, {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      })
      if (marker) {
        marker.setMap(null)
      }
      if (props.showPin) {
        marker = addMarker()
      }
    })
  }

  function addMarker() {
    const marker = new google.maps.Marker({
      position: coordinates,
      map,
    })
    marker.addListener('click', () => {
      const infowindow = new google.maps.InfoWindow({
        content: contentString.value,
      })
      infowindow.open({
        anchor: marker,
        map,
      })
    })
    return marker
  }
}

window.initMap = initMap

watch(
  () => [props.latitude, props.longitude],
  ([_newLat, _newLong], [_oldLat, _oldLong]) => {
    if (_newLat || _newLong) {
      coordinates.lat = _newLat
      coordinates.lng = _newLong
    }
  },
)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.hideCoordinates)
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 0,
          label: _ctx.$t('saveNewCoordinates'),
          format: _unref(FORMATS).SECONDARY,
          size: _unref(SIZES).SMALL,
          disabled: __props.disabled,
          class: "map__button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('coordinates', coordinates)), ["prevent"]))
        }, null, 8, ["label", "format", "size", "disabled"]))
      : _createCommentVNode("", true),
    _hoisted_2
  ]))
}
}

})